import { render, staticRenderFns } from "./modalVisualizarUra.vue?vue&type=template&id=0e138fc3&scoped=true"
import script from "./modalVisualizarUra.vue?vue&type=script&lang=js"
export * from "./modalVisualizarUra.vue?vue&type=script&lang=js"
import style0 from "./modalVisualizarUra.vue?vue&type=style&index=0&id=0e138fc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e138fc3",
  null
  
)

export default component.exports